<div class="modal-header">
	<ng-container>
		<h2 class="modal-title">Scanner un document</h2>
		<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
	</ng-container>
</div>

<div class="modal-body">
	<p class="form-label">Sélectionnez un appareil et numérisez un fichier :</p>
	<select class="scanner-select" id="sources">
	</select
	><br />
	<div id="dwtcontrolContainer"></div>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-primary btn-sm" (click)="acquireImage()">Scan Document</button>
	<button type="button" class="btn btn-primary btn-sm" [disabled]="!hasDocumentInBuffer" (click)="getDocumentFromScan()">Ajouter document</button>
	<button type="button" class="btn btn-secondary btn-sm" (click)="onClose()">
		<i class="far fa-times"></i>
		{{ 'Actions.Cancel' | translate }}
	</button>
</div>
